import useSWR from 'swr';
import { PermissionDetail } from '@webapp/bff';
import { trpc } from '../config/trpc';

export default function useOrgPermissions(orgId: string) {
  const { data, error, isLoading } = useSWR<PermissionDetail[]>(
    'useOrgPermissions',
    () => trpc.org.getOrgPermissions.query({ orgId }),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
    }
  );

  return {
    data,
    error,
    isLoading,
  };
}
